module.exports = __webpack_public_path__ + "static/sterling_395x344-a6cdf9d2783c05116ad13d8f64c924bb.webp";